import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { REPORT_DIALOG_CUSTOM_STYLE, ReportDialogStyleConfig } from '../../report-dialog/report-dialog.component';

@Component({
  selector: 'ebw-monorepo-map-table-feature-detail',
  templateUrl: './map-table-feature-detail.component.html',
  styleUrls: ['./map-table-feature-detail.component.scss']
})
export class MapTableFeatureDetailComponent implements OnInit, OnChanges {
  @Input() details: { title: string; data: any[]; index: number }[] = [];
  @Input() index: number;
  @Output() changeDetail: EventEmitter<number> = new EventEmitter<number>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  public detail = null;
  public readonly customReportStyle: ReportDialogStyleConfig = REPORT_DIALOG_CUSTOM_STYLE;

  constructor(private _changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._changeDetectorRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.index) {
      this.index = changes.index.currentValue;
      this.detail = this.details[this.index];
    }
  }

  public onClose() {
    this.close.emit();
  }

  public onPrevDetail() {
    if (this.index > 0) {
      this.index--;
      this._getDetail();
    }
  }

  public onNextDetail() {
    if (this.index < this.details.length - 1) {
      this.index++;
      this._getDetail();
    }
  }

  private _getDetail() {
    if (!this.details[this.index]) {
      this.changeDetail.emit(this.index);
      return;
    }

    this.detail = this.details[this.index];
  }
}
